import { FC } from 'react';

import { Box, Typography } from '@mui/material';

interface CardSection {
    heading: string;
}

export const CardSection: FC<CardSection> = ({ heading, children }) => {
    return (
        <Box>
            <Typography color="#1D1D1B" fontSize="24px" lineHeight="34.3px" fontWeight="500">
                {heading}
            </Typography>
            <Box height="1px" width="100%" bgcolor="#F18F34" marginY="8px" />

            <Box paddingTop="24px">{children}</Box>
        </Box>
    );
};
